import { render } from "./TransactionsPage.vue?vue&type=template&id=9bbb38fa&ts=true"
import script from "./TransactionsPage.vue?vue&type=script&lang=ts"
export * from "./TransactionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__